import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';

@Component<IssueItemFooterMixin>({})
export default class IssueItemFooterMixin extends IssueItemBaseMixin {}
